var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 11H5.5C4.48892 11 3.66667 11.8223 3.66667 12.8333V14.6667C3.66667 15.6778 4.48892 16.5 5.5 16.5H7.33333C8.34442 16.5 9.16667 15.6778 9.16667 14.6667V12.8333C9.16667 11.8223 8.34442 11 7.33333 11ZM5.5 14.6667V12.8333H7.33333V14.6667H5.5ZM17.4167 1.83333H16.5V0.916667C16.5 0.410667 16.0903 0 15.5833 0C15.0764 0 14.6667 0.410667 14.6667 0.916667V1.83333H7.33333V0.916667C7.33333 0.410667 6.92358 0 6.41667 0C5.90975 0 5.5 0.410667 5.5 0.916667V1.83333H4.58333C2.05608 1.83333 0 3.88942 0 6.41667V17.4167C0 19.9439 2.05608 22 4.58333 22H17.4167C19.9439 22 22 19.9439 22 17.4167V6.41667C22 3.88942 19.9439 1.83333 17.4167 1.83333ZM4.58333 3.66667H17.4167C18.9328 3.66667 20.1667 4.9005 20.1667 6.41667V7.33333H1.83333V6.41667C1.83333 4.9005 3.06717 3.66667 4.58333 3.66667ZM17.4167 20.1667H4.58333C3.06717 20.1667 1.83333 18.9328 1.83333 17.4167V9.16667H20.1667V17.4167C20.1667 18.9328 18.9328 20.1667 17.4167 20.1667Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.87dedd22c57e8d7dfc63b4efdfb0da4d.svg";
export { ForwardRef as ReactComponent };